"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRuleNotEffectiveError = void 0;
exports.isRuleEffective = isRuleEffective;
exports.applyTax = applyTax;
const money_1 = require("../money");
class TaxRuleNotEffectiveError extends Error {
    constructor(ruleId, asOf) {
        super('tax rule ' + ruleId + ' is not effective on ' + asOf);
        this.name = 'TaxRuleNotEffectiveError';
    }
}
exports.TaxRuleNotEffectiveError = TaxRuleNotEffectiveError;
function isRuleEffective(rule, asOf) {
    if (asOf < rule.effectiveFrom)
        return false;
    if (rule.effectiveTo && asOf > rule.effectiveTo)
        return false;
    return true;
}
const ZERO_RATED = ['zero', 'exempt', 'out_of_scope'];
/**
 * يحسب الضريبة على وعاء ويُنتج snapshot غير قابل للتغيير يُحفظ مع القيد.
 * المعالجات المعفاة والصفرية وخارج النطاق تُنتج صفرًا مع الاحتفاظ بالأثر.
 */
function applyTax(base, rule, asOf, scale = 2) {
    if (!isRuleEffective(rule, asOf)) {
        throw new TaxRuleNotEffectiveError(rule.id, asOf);
    }
    const amount = ZERO_RATED.includes(rule.treatment)
        ? money_1.Money.zero()
        : base.mul(rule.ratePercent).div('100').round(scale, 'half_up');
    return {
        amount,
        snapshot: {
            ruleId: rule.id,
            ruleVersion: rule.version,
            treatment: rule.treatment,
            ratePercent: rule.ratePercent,
            base: base.toString(),
            amount: amount.toString(),
            effectiveFrom: rule.effectiveFrom,
            recoverable: rule.recoverable,
        },
    };
}
//# sourceMappingURL=tax-rule.js.map